let ENDPOINT = "";

if (process.env.NODE_ENV === "production") {
  ENDPOINT = "https://threed-art-gallery-backend.onrender.com";
} else if (process.env.NODE_ENV === "development") {
  ENDPOINT = "http://localhost:3005"; 
}

export default ENDPOINT;
